// extracted by mini-css-extract-plugin
export default {"backgroundTitle":"styles_backgroundTitle__0JJFr","background":"styles_background__GuwaI","centerVertically":"styles_centerVertically__OjnZM"};